module.exports = __webpack_public_path__ + "img/kantina.7c39fd55.jpg";